module.exports = __webpack_public_path__ + "static/media/booth-curtain.e87c0222.svg";